import { useContext } from 'react';
import { StudentGroupContext } from '../context/StudentGroupContext';

export default function useStudentGroups(schoolYear: string) {
  const { groups, loading, refetch } = useContext(StudentGroupContext);

  return { groups: groups[schoolYear] || [], loading, refetch };
}
